// packages/main-app/src/config/env.ts

/** 环境配置 */
export interface EnvConfig {
  /** 本地 `pnpm start`，子应用入口为 localhost */
  isDevelopment: boolean;
  /** 构建产物 BUILD_ENV=development（部署用开发机） */
  isDeployedDevelopment: boolean;
  isTest: boolean;
  isGray: boolean;
  isProduction: boolean;
  keyboardEntry: string;
  mouseEntry: string;
  earphoneEntry: string;
}

/** 获取环境配置 */
export const getEnvConfig = (): EnvConfig => {
  const b = process.env.BUILD_ENV;
  const isDevelopment = b === "dev";
  const isDeployedDevelopment = b === "development";
  const isTest = b === "test";
  const isGray = b === "gray";
  const isProduction = b === "prod";

  return {
    isDevelopment,
    isDeployedDevelopment,
    isTest,
    isGray,
    isProduction,
    keyboardEntry: isDevelopment
      ? "//localhost:8081"
      : `${window.location.origin}/keyboard/`,
    mouseEntry: isDevelopment
      ? "//localhost:8082"
      : `${window.location.origin}/mouse/`,
    earphoneEntry: isDevelopment
      ? "//localhost:8083"
      : `${window.location.origin}/earphone/`,
  };
};
